import { useQueryApi } from 'utils/api'
import { apiPaths, handleError, queryKeys, validateStatus } from './config'

import type { UseQueryOptions } from 'react-query'
import type { CommonResponse } from 'types/api'
import type {
  PSPegawaiProfile,
  PSPegawaiProfileWithInstitution,
} from 'types/kinerja-ps-pegawai'

type ProfileResponse = CommonResponse<PSPegawaiProfile>

export function useAPIGetPSPegawaiProfile(
  options: UseQueryOptions<ProfileResponse>
) {
  return useQueryApi<ProfileResponse>(apiPaths.profile, {
    queryKey: [queryKeys.API_GET_PROFILE],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 60 * 60 * 1000, // 1 hour
      ...options,
    },
    errorHandlerFn: handleError,
  })
}

export function useAPIGetPSPegawaiProfileByID({
  pengawasSekolahId,
  options = {},
}: {
  pengawasSekolahId: string
  options?: UseQueryOptions<PSPegawaiProfileWithInstitution>
}) {
  return useQueryApi<PSPegawaiProfileWithInstitution>(
    `${apiPaths.profile}/${pengawasSekolahId}`,
    {
      queryKey: [
        queryKeys.API_GET_PROFILE,
        {
          pengawasSekolahId,
        },
      ],
      axiosConfig: {
        validateStatus,
      },
      queryConfig: {
        useErrorBoundary: false,
        staleTime: 60 * 60 * 1000, // stale after 60 min
        ...options,
      },
      errorHandlerFn: handleError,
    }
  )
}
